import React from 'react';
import { StyleSheet, useWindowDimensions } from 'react-native';

import { ds } from '@/components/lib/design.system';
import { useAndroidRerenderOnAppStateChange } from '@/components/player-profile/hooks/use-skia-image-cache';
import {
    CONTAINER_SIZE,
    PADDING_HORIZONTAL,
    PADDING_RIGHT_PLAYER_IMAGE,
} from '@/feature/player-profile-sheets/utils/player-profile-utils';
import { useSkiaFont } from '@/hooks/use-skia-font';
import { BlurMask, Canvas, Group, Mask, Rect, SkFont, Text as SkiaText } from '@shopify/react-native-skia';

const TEXT_CONTAINER_HEIGHT = 36;
const TEXT_SIZE = 30;

export const PlayerLastNameWithMask = ({ lastName }: { lastName: string }) => {
    const { width: screenWidth } = useWindowDimensions();

    const font = useSkiaFont(require('../../../assets/fonts/gamay-extrabold.ttf'), TEXT_SIZE);
    const padding = 16;

    useAndroidRerenderOnAppStateChange();

    if (!font) {
        return null;
    }

    const textWidth = font.measureText(lastName).width;
    const textAvailableWidth =
        screenWidth - (CONTAINER_SIZE.width + PADDING_RIGHT_PLAYER_IMAGE + 2 * PADDING_HORIZONTAL);

    const needsRightMask = textWidth > textAvailableWidth;
    const needsLeftMask = needsRightMask && textWidth > screenWidth - textAvailableWidth;
    const noNeedForMask = !needsLeftMask && !needsRightMask;

    return (
        <Canvas style={styles.canvas}>
            {noNeedForMask ? (
                <PlayerName lastName={lastName} font={font} />
            ) : (
                <Group>
                    <Mask
                        mode="alpha"
                        mask={
                            <Group>
                                {needsRightMask ? (
                                    <Rect
                                        x={-16}
                                        y={0}
                                        width={textAvailableWidth + padding + 20}
                                        height={TEXT_CONTAINER_HEIGHT}
                                        color={ds.colorValue.text.primary}
                                    >
                                        <BlurMask blur={10} style="normal" />
                                    </Rect>
                                ) : null}

                                {needsLeftMask ? (
                                    <Rect
                                        x={textAvailableWidth + CONTAINER_SIZE.width - 22}
                                        y={0}
                                        width={textAvailableWidth + CONTAINER_SIZE.width}
                                        height={TEXT_CONTAINER_HEIGHT}
                                        color={ds.colorValue.text.primary}
                                    >
                                        <BlurMask blur={10} style="normal" />
                                    </Rect>
                                ) : null}
                            </Group>
                        }
                    >
                        <PlayerName lastName={lastName} font={font} />
                    </Mask>
                </Group>
            )}
        </Canvas>
    );
};

const PlayerName = ({ lastName, font }: { lastName: string; font: SkFont }) => {
    return (
        <SkiaText x={0} y={TEXT_SIZE} text={lastName.toUpperCase()} font={font} color={ds.colorValue.text.primary} />
    );
};

const styles = StyleSheet.create({
    canvas: {
        height: TEXT_CONTAINER_HEIGHT,
    },
});
